import {
    GetManualLogHistoryPayLoad,
    GetManualLogHistoryResponse,
    ManualLogStatus,
} from '@/models/manualLog';
import axiosService from '@/services/axios/axios.service';

const handleRequestManualLog = async (payload: {
    manualLogId: string;
    status: ManualLogStatus;
}): Promise<NonNullable<any>> => {
    const res = await axiosService.post(
        'manual-log/update-manual-log',
        payload
    );
    return res.data;
};

const getManualLog = async (
    payload: GetManualLogHistoryPayLoad
): Promise<NonNullable<GetManualLogHistoryResponse>> => {
    const res = await axiosService.get(
        `manual-log/get-manual-logs-by-manager?status=${payload.status ? payload.status : 'all'}&uid=${payload.uid}&startDate=${payload.startDate}&endDate=${payload.endDate}&page=${payload.page}&limit=${payload.limit}`
    );
    return res.data;
};

const acceptAllPendingManualLogs = async (payload: {
    startDate?: string;
    endDate?: string;
}): Promise<{ accepted: number; failed: number; total: number }> => {
    const res = await axiosService.post(
        'manual-log/accept-all-pending',
        payload,
        { timeout: 120000 }
    );
    return res.data;
};

const findDuplicateManualLogs = async (payload: {
    startDate?: string;
    endDate?: string;
}): Promise<{
    duplicates: {
        uid: string;
        day: string;
        userName: string;
        count: number;
        totalMinutes: number;
        logs: {
            manualLog: any;
            task: any;
            project: any;
        }[];
    }[];
    total: number;
}> => {
    const res = await axiosService.get(
        `manual-log/find-duplicates?startDate=${payload.startDate || ''}&endDate=${payload.endDate || ''}`
    );
    return res.data;
};

export { handleRequestManualLog, getManualLog, acceptAllPendingManualLogs, findDuplicateManualLogs };
